/*
 * Copyright (c) 2024-2026. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import UiTableSkeletonRow from './UiTableSkeletonRow'

interface UiTableSkeletonRowsListProps {
    rows: number
    colSpan: number
    className?: string
}

const UiTableSkeletonRowsList = (props: UiTableSkeletonRowsListProps) => {
    const items = Array.from({ length: props.rows })

    return (
        <>
            {items.map((_, index) => (
                <UiTableSkeletonRow
                    key={index}
                    colSpan={props.colSpan}
                    className={props.className}
                />
            ))}
        </>
    )
}

export default UiTableSkeletonRowsList
